/*  MUI  */
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    Grid,
    TextField,
    Typography
} from '@mui/material';
import { withTheme } from '@mui/styles';

/*  Shared  */
import { ImageUpload } from 'application/Shared/Components/Images';
import { Notify } from 'application/Shared/Helpers';
import { TenantSetting } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

/*  State  */
const state = (props) => ({
    brand: {
        brandEnabled: false,
        brandHex: props?.theme.palette.primary.main,
        brandLogo: null,
        brandName: ''
    },
    details: {
        billContactEmail: '',
        billContactName: '',
        billContactTitle: '',
        city: '',
        name: '',
        phone: '',
        state: '',
        streetAddress: '',
        zip: ''
    },
    loaded: false
});

class Branding extends Component {
    constructor(props) {
        super(props);
        this.state = state(props);

        const clientId = props?.match?.params?.clientId;
        /* requests */
        this.TenantSetting = new TenantSetting(clientId);
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = () => {
        this.loadBranding();
        this.loadDetails();
    };

    unload = () => {
        this.unmount = true;
        this.TenantSetting.cancel();
    };

    loadBranding = async () => {
        if (this.unmount) {
            return;
        }

        const { brand } = state();

        // TODO: Fix - SAAS-994
        // eslint-disable-next-line no-restricted-syntax
        for (const key in brand) {
            if (key) {
                // TODO: Fix - SAAS-994
                // eslint-disable-next-line no-await-in-loop
                const [err, value] = await this.TenantSetting.getValue(key);
                if (!err) {
                    brand[key] = value;
                }
            }
        }

        if (!this.unmount) {
            this.setState({ brand, loaded: true });
        }
    };

    loadDetails = async () => {
        if (this.unmount) {
            return;
        }

        const { details } = state();

        // TODO: Fix - SAAS-994
        // eslint-disable-next-line no-restricted-syntax
        for (const key in details) {
            if (key) {
                // TODO: Fix - SAAS-994
                // eslint-disable-next-line no-await-in-loop
                const [err, value] = await this.TenantSetting.getValue(key);
                if (!err) {
                    details[key] = value;
                }
            }
        }

        if (!this.unmount) {
            this.setState({ details });
        }
    };

    save = async () => {
        const { t, match } = this.props;
        const { partnerId } = match.params;

        const { brand, details } = this.state;
        const { brandEnabled, brandLogo, brandName, brandHex } = brand;
        const err = t('HubSettings.Branding.unableToSave');

        // Brand
        try {
            await axios.post('/tenantSetting', {
                key: 'brandEnabled',
                value: brandEnabled
            });

            await axios.post('/tenantSetting', {
                key: 'brandLogo',
                value: brandLogo
            });

            if (brandName) {
                await axios.post('/tenantSetting', {
                    key: 'brandName',
                    value: brandName
                });
            }
            if (brandHex) {
                await axios.post('/tenantSetting', {
                    key: 'brandHex',
                    value: brandHex
                });
            }
        } catch (e) {
            debug.e(err, e);
            Notify.e(err);
            return;
        }

        // Details
        try {
            // TODO: Fix - SAAS-994
            // eslint-disable-next-line no-restricted-syntax
            for (const key in details) {
                if (details[key]) {
                    const value = details[key];
                    // TODO: Fix - SAAS-994
                    // eslint-disable-next-line no-await-in-loop
                    await axios.post('/tenantSetting', { key, value });
                }
            }
        } catch (e) {
            debug.e(err, e);
            Notify.e(err);
            return;
        }

        this.props.setTenantIsStale(partnerId);

        Notify.s(t('HubSettings.Branding.saved'));
    };

    renderBrandHex = () => {
        const { t, theme } = this.props;
        const { brand } = this.state;
        const { brandHex } = brand;

        return (
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        style={{ fontWeight: 600 }}
                    >
                        {t('HubSettings.Branding.hex')}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <TextField
                        inputProps={{
                            'data-testid': 'hubSettingsBrandingPageBrandHex'
                        }}
                        onChange={(e) => {
                            this.setState({
                                brand: {
                                    ...brand,
                                    brandHex: e.target.value
                                }
                            });
                        }}
                        fullWidth
                        value={brandHex}
                        placeholder={theme.palette.primary.main}
                    />
                </Grid>
                <Grid item xs={1} style={{ paddingLeft: '20px' }}>
                    <div
                        style={{
                            background: brandHex,
                            border: '2px solid',
                            borderColor: theme.palette.border.primary,
                            height: '32px',
                            width: '50%'
                        }}
                    />
                </Grid>
            </Grid>
        );
    };

    renderBranding = () => {
        const { t } = this.props;
        const { brand } = this.state;
        const { brandEnabled, brandLogo, brandName } = brand;

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h4">
                        {t('HubSettings.Branding.brandDetails')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <FormControl
                        fullWidth
                        data-testid="brandingBrandingControl"
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    data-testid="brandingUseCustomBranding"
                                    checked={brandEnabled}
                                    onChange={(e) =>
                                        this.setState({
                                            brand: {
                                                ...brand,
                                                brandEnabled: e.target.checked
                                            }
                                        })
                                    }
                                />
                            }
                            label={t('Common.brandingCustom')}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        style={{ fontWeight: 600 }}
                    >
                        {t('AllClientSettings.product_name')}
                    </Typography>
                    <TextField
                        inputProps={{
                            'data-testid': 'hubSettingsBrandingPageBrandName'
                        }}
                        onChange={(e) => {
                            this.setState({
                                brand: { ...brand, brandName: e.target.value }
                            });
                        }}
                        fullWidth
                        value={brandName}
                    />
                </Grid>
                <Grid item xs={12}>
                    {this.renderBrandHex()}
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        style={{ fontWeight: 600 }}
                    >
                        {t('AllClientSettings.select_a_logo')}
                    </Typography>
                    <Box display="flex" alignItems="center">
                        {brandLogo && (
                            <>
                                <Box data-testid="hubSettingsBrandingCurrentBrandLogo">
                                    <img
                                        src={brandLogo}
                                        style={{
                                            height: 'max-content',
                                            width: '150px'
                                        }}
                                        aria-label="hidden"
                                    />
                                </Box>
                                <Box mx="32px">{t('Common.or')}</Box>
                            </>
                        )}
                        <Box data-testid="hubSettingsBrandingCurrentUploadLogo">
                            <ImageUpload
                                uploadFn={(v) => {
                                    this.setState({
                                        brand: {
                                            ...brand,
                                            brandLogo: atob(v)
                                        }
                                    });
                                }}
                                removeFn={() => {
                                    this.setState({
                                        brand: {
                                            ...brand,
                                            brandLogo: null
                                        }
                                    });
                                }}
                                brandLogoExists={!!brandLogo}
                                text={t('AllClientSettings.upload_logo')}
                                textDescription={t(
                                    'AllClientSettings.upload_logo_requirements'
                                )}
                                textSelect={t(
                                    'AllClientSettings.select_new_logo'
                                )}
                                textConfirm={t(
                                    'AllClientSettings.upload_new_logo'
                                )}
                                removeText={t('AllClientSettings.removeLogo')}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        );
    };

    renderDetail = (key) => {
        const { t } = this.props;
        const { details } = this.state;

        return (
            <Grid item xs={12} key={`setting_${key}`}>
                <Typography
                    color="textSecondary"
                    variant="body2"
                    style={{ fontWeight: 600 }}
                >
                    {t(`PartnerInformation.${key}`)}
                </Typography>
                <TextField
                    inputProps={{
                        'data-testid': `hubSettingsBrandingPage_${key}`
                    }}
                    onChange={(e) => {
                        this.setState({
                            details: { ...details, [key]: e.target.value }
                        });
                    }}
                    fullWidth
                    value={details[key]}
                />
            </Grid>
        );
    };

    render() {
        const { t } = this.props;
        const { loaded, details } = this.state;

        if (!loaded) {
            return (
                <Box
                    py="32px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress />
                </Box>
            );
        }

        return (
            <Grid
                container
                spacing={0}
                p={1}
                data-testid="hubSettingsBrandingPage"
            >
                {this.renderBranding()}
                <Grid item xs={12}>
                    <hr />
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography
                            variant="h4"
                            style={{ marginBottom: '8px' }}
                        >
                            {t('HubSettings.Branding.contactDetails')}
                        </Typography>
                    </Grid>
                    {Object.keys(details).map((s) => this.renderDetail(s))}
                </Grid>
                <Grid item xs={12}>
                    <hr />
                    <Box display="flex" justifyContent="flex-end">
                        <Button
                            data-trackid="partner_hubSettings_saveBranding"
                            data-testid="hubSettingsBrandingSaveBtn"
                            color="primary"
                            variant="contained"
                            onClick={() => this.save()}
                        >
                            {t('HubSettings.save_branding')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        );
    }
}
export default withRouter(withTranslation()(withTheme(Branding)));
